import { gql } from '@apollo/client';

const DELETE_NOTIFICATION_MUTATION = gql`
    mutation deleteNotification( $input: DeleteNotificationInput! ) {
        result: deleteNotification( input: $input ) {
            affectedRows
        }
    }
`;

export default DELETE_NOTIFICATION_MUTATION;
